import 'ol/ol.css';
import { Vector as VectorLayer, Heatmap } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { Style, Stroke, Fill, Text, RegularShape } from 'ol/style.js';
import GeoJSON from "ol/format/GeoJSON";
import Point from "ol/geom/Point";
import { interpolateColors, runAnimationFeature, setMapSingleEventHandler } from 'map/OlExtension'
import { getVectorContext } from 'ol/render';
import { unByKey } from 'ol/Observable';
import { getRandomIntInclusive, hexToRgba, settingsConfig } from 'utils/commonFunc';
import defColors from 'utils/defColors';

export default class DisplayLink2PolygonLayer extends VectorLayer {
    constructor(map) {
        super({
            name: 'linkLayer',
            opacity: settingsConfig().mapOpacityLink2 ?? 0.3,
            userLayer: true,
            layerIndex: 0,
        });
        this.map = map;
        this.map?.addLayer(this);
        this.setStyle(this.styleFunction)

        // if (settingsConfig().debugLayerPostrender) {
        //     const layerName = this.get('name')
        //     this.on('postrender', function (e) {
        //         console.log(`layer postrender ${layerName}`)
        //     });
        // }
    }

    styleCache = {};
    styleFunction = (feature, _) => {
        const lvl = feature.get('lvl')
        let style = this.styleCache[lvl];
        if (!style) {
            let color = 'rgb( 100, 100, 100)'//'rgba( 100, 100, 100, 1)'
            switch (lvl) {
                case 1:
                    color = defColors.trafficColors[2]//hexToRgba(, 1.0);
                    break;
                case 2:
                    color = defColors.trafficColors[1]//hexToRgba(defColors.trafficColors[1], 1.0);
                    break;
                case 3:
                    color = defColors.trafficColors[0]//hexToRgba(defColors.trafficColors[0], 1.0);
                    break;
                default:
                    break;
            }
            style = this.styleCache[lvl] = new Style({
                fill: new Fill({
                    color: color
                })
            });
        }

        return style
    }

    updateSpd = (items) => {
        this.getSource()?.forEachFeature(feature => {
            const id = feature.get("LINK2_ID")
            const lvl = items[id];

            if (feature.get("lvl") !== lvl) {
                feature.set("lvl", lvl)
            }
        });
    }
}